// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__EXzYV"};